import { render } from "./AppTransition.vue?vue&type=template&id=5fbfbf96&scoped=true"
import script from "./AppTransition.vue?vue&type=script&lang=js"
export * from "./AppTransition.vue?vue&type=script&lang=js"

import "./AppTransition.vue?vue&type=style&index=0&id=5fbfbf96&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fbfbf96"]])

export default __exports__